import withMetadataArgument from './withMetadataArgument.js'
import { findPhoneNumbersInText as _findPhoneNumbersInText } from '../../core/index.js'

export function findPhoneNumbersInText() {
	return withMetadataArgument(_findPhoneNumbersInText, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/findPhoneNumbersInText.js
// module id = 1613
// module chunks = 0